import React, { useState } from 'react';
import dayjs from 'dayjs';
import qs from 'qs';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { history, useIntl, useLocation } from 'umi';
import { useSelector, useDispatch } from 'dva';
import DataTableNativeML from '@/components/DataTableNativeML';
import { OPT_ADD, OPT_EDIT, OPT_DETAIL } from '@/constants';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import webStorage from '@/utils/storageManager';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import {
  UNDER_WAY,
  NOT_START,
  UNAPPROVED,
  END,
  STOP,
  APPROVE,
  DELETE,
} from '../../constants';
import ResultListStyled from './ResultListStyled';

const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();
  const { ACTIVITY_COUPON_STATUS } = webStorage.get('DICTOBJ') || {};
  const MENU_MARKETING_BENEFIT_COUPON_EDIT = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_BENEFIT_COUPON_EDIT');
  const MENU_MARKETING_BENEFIT_COUPON_DETAIL = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_BENEFIT_COUPON_DETAIL');
  const MENU_MARKETING_BENEFIT_COUPON_ADD = webStorage
    .get('USER')
    ?.authorities?.includes('MENU_MARKETING_BENEFIT_COUPON_ADD');
  const { query, pathname } = location;
  const { pageData } = props;
  const { handlePageChange } = props;
  //关于操作按钮二次弹出确认框
  const [openDialog, setOpenDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const actionList = [
    {
      type: STOP,
      dialogTitle: '终止',
      dialogContent: '确定要终止该活动吗',
    },
    {
      type: APPROVE,
      dialogTitle: '审核',
      dialogContent: '确定要通过审核吗？',
    },
    {
      type: DELETE,
      dialogTitle: '删除',
      dialogContent: '确定要删除该活动吗？',
    },
  ];

  const loadingEffect = useSelector((state) => state.loading);
  const listLoading =
    loadingEffect.effects['activityCouponList/getActivityList'];

  const { data: activityList, total } =
    useSelector((state) => state.activityCouponList?.activityList) || {};

  const columns = [
    {
      align: 'center',
      title: '编号',
      id: 'id',
    },
    {
      title: '名称',
      align: 'center',
      id: 'name',
      key: 'name',
    },
    {
      title: '活动时间',
      id: 'beginDateTime',
      key: 'beginDateTime',
      align: 'center',
      render: ({ beginDateTime, endDateTime }) => {
        const beginDate = dayjs(beginDateTime).format('YYYY-MM-DD');
        const endDate = dayjs(endDateTime).format('YYYY-MM-DD');
        return `${beginDate} ~ ${endDate}`;
      },
    },
    {
      title: '状态',
      align: 'center',
      id: 'status',
      key: 'status',
      render: ({ status }) => {
        return ACTIVITY_COUPON_STATUS?.find((i) => i.dictCode === status)
          ?.nameZh;
      },
    },
    {
      title: '操作',
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 180,
      render: (rowInfo) => {
        const id = rowInfo.id;
        const status = rowInfo.status;
        const canEdit = status !== END; //可以编辑
        const canApprove = status === UNAPPROVED; //可以审核
        const canStop = status === UNDER_WAY || status === NOT_START; //可以终止
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_voucher_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: rowInfo.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canEdit && MENU_MARKETING_BENEFIT_COUPON_EDIT) {
                    handleToBenefitVoucher(
                      OPT_EDIT,
                      id,
                      'btn_marketing_activity_voucher_list_edit',
                    );
                  }
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit && MENU_MARKETING_BENEFIT_COUPON_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={!canEdit && 'no-drop'}
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_voucher_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: rowInfo.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  MENU_MARKETING_BENEFIT_COUPON_DETAIL &&
                    handleToBenefitVoucher(
                      OPT_DETAIL,
                      id,
                      'btn_marketing_activity_voucher_list_details',
                    );
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={
                    MENU_MARKETING_BENEFIT_COUPON_DETAIL
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="终止">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_voucher_list_terminate',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: rowInfo.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canStop && MENU_MARKETING_BENEFIT_COUPON_EDIT) {
                    handleClickStop(id, STOP);
                  }
                }}
              >
                <SvgIconML
                  name="stop"
                  size={24}
                  fill={
                    canStop && MENU_MARKETING_BENEFIT_COUPON_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={
                    (!canStop || !MENU_MARKETING_BENEFIT_COUPON_EDIT) &&
                    'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>
            <ButtonTip title="审核">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_voucher_list_review',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: rowInfo.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (canApprove && MENU_MARKETING_BENEFIT_COUPON_EDIT) {
                    handleClickApprove(id, APPROVE);
                  }
                }}
              >
                <SvgIconML
                  name="approve"
                  size={24}
                  fill={
                    canApprove && MENU_MARKETING_BENEFIT_COUPON_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={
                    (!canApprove || !MENU_MARKETING_BENEFIT_COUPON_EDIT) &&
                    'no-drop'
                  }
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="小程序码">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  canEdit && handleClickQr(id);
                }}
              >
                <SvgIconML
                  name="couponImg"
                  size={24}
                  // fill={theme.palette.primary.main}
                  fill={
                    canEdit
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className={!canEdit && 'no-drop'}
                />
              </IconButton>
            </ButtonTip>

            <ButtonTip title="删除">
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_marketing_activity_voucher_list_delete',
                  events: ['_ev', '_ec'],
                  params: {
                    activity_id: rowInfo.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                // 删除
                onClick={() => {
                  MENU_MARKETING_BENEFIT_COUPON_EDIT &&
                    handleClickDelete(id, DELETE);
                }}
              >
                <SvgIconML
                  name="circleDelete"
                  size={22}
                  fill={
                    MENU_MARKETING_BENEFIT_COUPON_EDIT
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  const handleClickQr = (id) => {
    history.push({
      pathname: '/marketing/member_benefit_voucher/qr_code',
      query: {
        id: String(id),
        pathType: '1',
        sourceType: '2',
      },
    });
  };

  const handleToBenefitVoucher = (type, id, sourceOid) => {
    const path =
      type === OPT_ADD
        ? '/marketing/member_benefit_voucher/add'
        : type === OPT_EDIT
        ? '/marketing/member_benefit_voucher/edit'
        : '/marketing/member_benefit_voucher/detail';
    history.push({
      pathname: path,
      query: {
        opt: type,
        id,
        sourceOid,
      },
    });
  };
  //处理审核
  const handleClickApprove = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'activityCouponList/activityApprove',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '审核成功',
              title: '成功',
            });
            const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
            history.replace(
              `${pathname}?${qs.stringify({
                ...query,
                refreshTime,
              })}`,
            );
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };
  //删除
  const handleClickDelete = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'activityCouponList/activityDelete',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '成功',
            });
            const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
            history.replace(
              `${pathname}?${qs.stringify({
                ...query,
                refreshTime,
              })}`,
            );
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };

  //处理活动暂停
  const handleClickStop = (id, type) => {
    const action = actionList.find((i) => i.type === type);
    action.confirm = () => {
      dispatch({
        type: 'activityCouponList/activityPause',
        payload: {
          values: {
            id,
          },
        },
        callback: (res) => {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '终止成功',
              title: '成功',
            });
            const refreshTime = dayjs().format('YYYY-MM-DD :HH-mm-ss');
            history.replace(
              `${pathname}?${qs.stringify({
                ...query,
                refreshTime,
              })}`,
            );
          }
        },
      });
      setOpenDialog(false);
    };
    setCurrentAction(action);
    setOpenDialog(true);
  };
  //换页
  const changePage = ({ pageNum, pageSize }) => {
    handlePageChange({ ...pageData, pageNum, pageSize });
  };

  return (
    <ResultListStyled>
      <div className="export-wrapper">
        <Fab
          data-log={JSON.stringify({
            oid: 'btn_marketing_activity_voucher_list_create',
            events: ['_ev', '_ec'],
            params: {
              initUrl: window.location.origin + window.location.pathname,
            },
          })}
          variant="extended"
          size="small"
          color="primary"
          aria-label="add"
          className="export"
          sx={{ marginRight: '16px' }}
          disabled={!MENU_MARKETING_BENEFIT_COUPON_ADD}
          onClick={() =>
            handleToBenefitVoucher(
              OPT_ADD,
              '',
              'btn_marketing_activity_voucher_list_create',
            )
          }
        >
          <AddIcon sx={{ width: '24px', height: '24px' }} />
          新建活动
        </Fab>
      </div>
      <DataTableNativeML
        columns={columns}
        loading={listLoading}
        changePage={changePage}
        page={pageData}
        data={activityList}
        devicesMinWidth={1640}
        total={total}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
    </ResultListStyled>
  );
};
export default ResultList;
